import { useState, useEffect } from 'preact/hooks';
import useVendor from './useVendor';
import { s3DataPrefix } from '../config/app';
import { HookState } from '../types/hooks';

/**
 * Fetch product information
 * @return {{data: Object|null, loading: boolean, error: boolean}}
 */
const useProductInformation = (): HookState => {
    const [status, setStatus] = useState({
        loading: true,
        error: false,
        data: null,
    });

    const vendor = useVendor();

    useEffect(() => {
        (async () => {
            // Declaring these variables inside try{...} statement
            // leads to a babel compilation error when running Jest tests.
            let response: Response, data: any;

            try {
                response = await fetch(`/${s3DataPrefix}/products/${vendor}.json`);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`);
                }

                data = await response.json();
                setStatus({ loading: false, error: false, data });
            } catch (error: any) {
                console.error(`Product information error: ${error.message}`);
                setStatus({ loading: false, error: true, data: null });
            }
        })();
    }, [vendor]);

    return status;
};

export default useProductInformation;
